import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Paragraph } from 'components/patterns'
import Editor from 'components/Editor'

export const StyledDomainParagraph = styled(Paragraph)`
  border-bottom: 1px solid ${themeColor('paragraphColor')};
  margin-bottom: 10px;
  margin-top: 1.5em;
`

export const StyledEditor = styled(Editor)`
  overflow-y: auto;
`
